import { addressSelector } from '@stores/address';
import { useSession } from 'next-auth/react';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { IoMdArrowDropdown } from 'react-icons/io';
import usePopup from '@hooks/usePopup';
import AddressControlModal from '@containers/address/popups/address-control.modal';
import ROUTER from '@constants/router';

export default function UnauthedHeaderAddress() {
  const { currentAddress } = useSelector(addressSelector);
  const { status } = useSession();
  const { openPopup } = usePopup();
  const router = useRouter();

  const handleAddressClick = () => {
    status === 'authenticated'
      ? openPopup({
          id: 'address',
          isOpen: true,
          Component: AddressControlModal,
          type: 'drawer',
          props: {},
          popupOptions: { placement: 'bottom', size: 'xl' },
        })
      : router.push(ROUTER.address);
  };

  return (
    <>
      {currentAddress && (
        <div
          className="cursor-pointer flex gap-[6px] items-center"
          onClick={handleAddressClick}
        >
          <div>
            <p className="text-[16px]">{currentAddress.alias}</p>
            <p className="text-secondary-300 text-[10px]">
              {currentAddress.address}
            </p>
          </div>
          <div>
            {status === 'authenticated' && <IoMdArrowDropdown size="24px" />}
          </div>
        </div>
      )}
    </>
  );
}
